import React from "react";

const PeripheralSmearProfile = ({
  profile,
  testMap,
  handleTestProfileChange,
}) => {
  return (
    <>
      <h4 style={{ marginTop: "20px", fontWeight: "600" }}>
        Peripheral Smear Comment
      </h4>

      {profile?.tests?.map((item, index) => {
        const testId = item?.id || item?._id;
        const profileId = profile?.id || profile?._id;

        const testData =
          testMap.get(testId) || testMap.get(String(testId)) || {};

        return (
          <div
            key={testId || index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              marginBottom: "12px",
              padding: "10px",
              background: index % 2 === 0 ? "#f5f5f5" : "transparent",
              borderRadius: "6px",
            }}
          >
            <label
              style={{
                minWidth: "150px",
                fontWeight: "500",
              }}
            >
              {item?.testName}
            </label>

            <textarea
              value={testData.value || ""}
              onChange={(e) =>
                handleTestProfileChange(e, "value", profileId, testId)
              }
              rows={3}
              style={{
                width: "350px",
                padding: "8px",
                borderRadius: "6px",
                border: "1px solid #d1d5db",
                fontSize: "13px",
                resize: "none",
              }}
            />
          </div>
        );
      })}
    </>
  );
};

export default PeripheralSmearProfile;
